import * as turf from '@turf/turf'
import {utcToZonedTime} from "date-fns-tz";
import {stations} from "./stations";
import {format} from "date-fns";

export const whichPointWithinStation = (pts) => {

    const points = [...pts]; // Shallow Copy

    const turf_points = [];
    points.map((point) => {
        turf_points.push(
            turf.point(point.location.coordinates, {point_id: point.id})
        )
    });

    let multiPts = turf.featureCollection([...turf_points])
    // console.log("multipuntos", multiPts);

    const turf_polygons = [];
    stations.map((station) => {
        turf_polygons.push(
            turf.polygon(
                [[...station.area.coordinates[0].map(e => e.reverse())]],
                {
                    station_id: station.id,
                })
        );
    })

    const stationPoints = {};
    for (const turfPolygon of turf_polygons) {
        stationPoints[turfPolygon.properties.station_id] = turf.pointsWithinPolygon(multiPts, turfPolygon);
    }

    // console.log(stationPoints);

    for (const stationPoint of Object.keys(stationPoints)) {
        for (const stationPointElement of stationPoints[stationPoint].features) {
            let point = points.findIndex((e) => e.id === stationPointElement.properties.point_id)
            points[point]['station_id'] = stationPoint;
            points[point]['station_name'] = stations.filter((e) => e.id === parseInt(stationPoint))[0].name ?? '';
        }
    }

    return points;
}

/** Example Poli */
// let poli = stations.filter((station) => {
//     return station.id === 2
// })[0];
//
// let poli_station = turf.polygon(
//     [[...poli.area.coordinates[0].map(e => e.reverse())]],
//     {
//         station_id: poli.id,
//     })
//
// console.log("station", JSON.stringify(poli_station));


/**
 * Helper Function to calculate datasets
 * @returns {{going: *[], coming: *[]}}
 * @param dataFromPoint
 * @param orientation
 * @param nearestStation
 */
export const getComingAndGoingDataset = (dataFromPoint, orientation, nearestStation) => {
    // console.log(dataFromPoint);

    const coming = [];
    const going = [];
    const saved = [];

    // Remove Pension and organize
    // [meters, station, orientation, bus_number, dataFromApi]
    for (let pointIndex in nearestStation) {
        pointIndex = parseInt(pointIndex);
        if (nearestStation[pointIndex][1] !== 20) {
            if (orientation[pointIndex] === 1) {
                coming.push([...nearestStation[pointIndex], orientation[pointIndex], pointIndex, {data: dataFromPoint.filter((p) => p.unit_id === pointIndex)[0]}])
            } else {
                going.push([...nearestStation[pointIndex], orientation[pointIndex], pointIndex, {data: dataFromPoint.filter((p) => p.unit_id === pointIndex)[0]}])
            }
        }
        // if station is pension
        if (nearestStation[pointIndex][1] === 20) {
            saved.push([...nearestStation[pointIndex], {data: dataFromPoint.filter((p) => p.unit_id === pointIndex)[0]}]);
        }
    }

    return {
        coming: coming,
        going: going,
        saved: saved
    }
}

/**
 * Easy function to clean an array of points
 * @param dataset
 * @param unit_numbers
 * @returns {*}
 */
export const filterDatasetWithUnitNumbers = (dataset, unit_numbers) => {
    return dataset.filter((set) => {
        return unit_numbers.includes(parseInt(set["unit_number"]));
    });
}

/**
 * Wrapper for dataset
 * @param dataset
 * @param unit_numbers
 * @returns {*}
 */
export const wrapperForComingAndGoingDataset = (dataset, unit_numbers) => {
    unit_numbers = unit_numbers.map(u => parseInt(u));
    return dataset.filter(([meter, nearest_station, orientation, id, {data}]) => {
        return unit_numbers.includes(parseInt(data["unit_number"]));
    });
}

/**
 * Filter function for the right menu
 * @param unit_numbers
 * @param checked
 * @returns {*}
 */
export const diffWithChecked = (unit_numbers, checked) => {
    checked = checked.map(u => parseInt(u));
    return unit_numbers.filter(ui => {
        return checked.includes(parseInt(ui));
    })
}

/**
 * Convert ISO-UTC date into Mexico's zoned date
 * @param date
 * @param withMinutes
 * @returns {string}
 */
export const dateToMexico = (date, withMinutes = true) => {
    const dateObj = new Date(date)
    const timeZone = 'America/Mexico_City'
    const zonedDate = utcToZonedTime(dateObj, timeZone)
    const minutes = withMinutes ? " HH:mm:ss" : "";
    return format(zonedDate, "yyyy/MM/dd" + minutes);
}